import React, {useState} from "react";
import {validation} from "../../../helpers/ValidationHelper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    selectControl: {
        width: 165
    }
}));

const baudRates = [110, 300, 600, 1200, 2400, 4800, 9600, 14400, 19200, 38400, 57600, 115200, 128000, 256000];
const dataBits = [5, 6, 7, 8];
const stopBits = [1, 1.5, 2];
const parities = [
    {title: "None", value: 0},
    {title: "Odd", value: 1},
    {title: "Even", value: 2},
    {title: "Mark", value: 3},
    {title: "Space", value: 4}
];

function validatePortValue(value) {
    return !!value.length;
}

export default function DeviceSerialTransport({deviceId, settings, onChange, onValidationSuccess, onValidationError}) {
    const classes = useStyles();

    const [validationErrors, setValidationErrors] = useState({});

    function handleSetValidationErrors(value) {
        setValidationErrors(value);

        Object.keys(value).length
            ? onValidationSuccess()
            : onValidationError();
    }

    function handlePortChange(event) {
        handleSetValidationErrors(
            validation(
                event.target.value,
                "port",
                validationErrors,
                validatePortValue
            )
        );

        onChange({"port": event.target.value});
    }

    function handleBaudRateChange(event) {
        onChange({"baud_rate": event.target.value});
    }

    function handleDataBitsChange(event) {
        onChange({"data_bits": event.target.value});
    }

    function handleStopBitsChange(event) {
        onChange({"stop_bits": event.target.value});
    }

    function handleParityChange(event) {
        onChange({"parity": event.target.value});
    }

    return (
        <Grid container spacing={2} direction={"column"} justify={"center"} alignItems={"center"}>
            <Grid item xs={12}>
                <TextField
                    id="serial-port"
                    label="Port"
                    fullWidth
                    value={settings.port}
                    error={validationErrors["port"]}
                    inputProps={{
                        style: {textAlign: "center"}
                    }}
                    onChange={handlePortChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.selectControl}>
                    <InputLabel id="serial-baud-rate-label">
                        Baud Rate
                    </InputLabel>
                    <Select id="serial-baud-rate"
                            value={settings["baud_rate"]}
                            onChange={handleBaudRateChange}
                    >
                        {
                            baudRates.map((item, index) => (
                                <MenuItem key={`serial-baud-rate-${deviceId}-${index}`} value={item}>{item}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.selectControl}>
                    <InputLabel id="serial-data-bits-label">
                        Data Bits
                    </InputLabel>
                    <Select id="serial-data-bits"
                            value={settings["data_bits"]}
                            onChange={handleDataBitsChange}
                    >
                        {
                            dataBits.map((item, index) => (
                                <MenuItem key={`serial-data-bits-${deviceId}-${index}`} value={item}>{item}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.selectControl}>
                    <InputLabel id="serial-stop-bits-label">
                        Stop Bits
                    </InputLabel>
                    <Select id="serial-stop-bits"
                            value={settings["stop_bits"]}
                            onChange={handleStopBitsChange}
                    >
                        {
                            stopBits.map((item, index) => (
                                <MenuItem key={`serial-stop-bits-${deviceId}-${index}`} value={item}>{item}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.selectControl}>
                    <InputLabel id="serial-parity-label">
                        Parity
                    </InputLabel>
                    <Select id="serial-parity"
                            value={settings["parity"]}
                            onChange={handleParityChange}
                    >
                        {
                            parities.map((item, index) => (
                                <MenuItem key={`serial-parity-${deviceId}-${index}`}
                                          value={item.value}
                                >
                                    {item.title}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}